import { ReactComponent as Ic_Airport } from 'resources/icons/Ic_Airport.svg';
import { ReactComponent as Ic_Warning_Circle } from 'resources/icons/Ic_Warning_Circle.svg';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { CSSProperties } from 'react';
import './buttonLine.scss';

const AEROPUERTO = 'aeroport';
const CIRCULAR = 'circular';

interface IBLine {
  lineId?: string;
  code?: string;
  routeColor: string;
  routeTextColor?: string;
  border?: string;
  selected?: boolean;
  name?: string;
  warning?: boolean;
  styles?: CSSProperties;
  onClick?: null | any;
}

const getStyle = (text, routeColor, styles, click) => {
  let style = {};
  if (text?.toLocaleLowerCase().includes(CIRCULAR)) {
    style = { outline: `${routeColor} solid 1px`, border: '1px solid #FFF' };
  } else if (text?.toLocaleLowerCase().includes('aeroport')) {
    style = { border: 'solid 1px #000', color: '#000', minHeight:'20px', minWidth:'38px' };
  } else {
    style = { border: `solid 1px ${routeColor}` };
  }

  style = { ...style, background: routeColor, ...styles };
  const isPointer = click ? 'pointer' : 'auto';
  return { ...style, cursor: isPointer };
};

export default function ButtonLine({
  name,
  code,
  routeColor,
  routeTextColor,
  border,
  onClick,
  selected = true,
  warning,
  styles,
}: IBLine) {
  //const { text, routeColor, routeTextColor, border } = props;
  routeColor =
    routeColor !== null && routeColor !== undefined
      ? routeColor[0] === '#'
        ? routeColor
        : '#' + routeColor
      : '#314450';
  routeTextColor =
    routeTextColor !== null && routeTextColor !== undefined
      ? routeTextColor[0] === '#'
        ? routeTextColor
        : '#' + routeTextColor
      : name?.toLocaleLowerCase().includes(AEROPUERTO) ? '#000' : '#FFF';
  return (
    <div
      className={`buttonLine ${!selected ? '--unselected' : ''}`}
      style={getStyle(name, routeColor, styles, onClick)}
      onClick={() => onClick && onClick()}
    >
      <div className='buttonLine_content' style={{ color: routeTextColor }}>
        <span style={{ marginTop:'2px', minHeight:'16px',  }}>{code}</span>
        {name?.toLocaleLowerCase().includes(AEROPUERTO) ? (
          <div style={{ marginTop:'3px', minHeight:'16px' }}><SvgIcon className='airport-icon' ariaLabel='Icono' Icon={Ic_Airport} style={{ width: '5px', height: '5px', marginTop:'3px'  }} /></div>
        ) : (
          ''
        )}
      </div>
      {warning && <SvgIcon Icon={Ic_Warning_Circle} className='warning-icon' ariaLabel='warning' />}
    </div>
  );
}
